import {get,post} from '../utils/request';
import qs from 'qs'

const reqURL= location.protocol + '//' + location.host +'/wxapi/api/';
// const reqURL= 'http://wx.hnskssoft.com/wxapi/api/';

//获取AccsessToken
export function getAccsessToken (query) {
  return post(reqURL+'Geren/GetAccsessToken?'+qs.stringify(query))
}
//刷新AccsessToken
export function getRefreshToken (query) {
  return post(reqURL+'Geren/GetRefreshToken?'+qs.stringify(query))
}
//获取个人信息
export function getUserInfo (query) {
  return post(reqURL+'Geren/GetUserInfo?'+qs.stringify(query))
}
// export function gerenGetInfo (query) {
//   return post(reqURL+'Geren/GetInfo',query)
// }
//登录
export function gerenLoginIn (query) {
  return post(reqURL+'Geren/LoginIn?'+qs.stringify(query))
}
//健康卡列表
export function getCardList (query) {
  return post(reqURL+'HealthCard/GetCardList?'+qs.stringify(query))
}
//获取单个健康卡详细信息/就诊人详情页
export function getCardOne (query) {
  return post(reqURL+'HealthCard/GetCardOne/'+query)
}
//根据上传的身份证图片，获得识别后的身份证基本信息
export function byIdCardImage (query) {
  return post(reqURL+'HealthCard/GetBaseInfo_ByIdCardImage',query)
}
//注册健康卡
export function registerByBaseInfo (query) {
  return post(reqURL+'HealthCard/Register_ByBaseInfo',query)
}
//科室列表
export function guidanceGetks (query) {
  return post(reqURL+'Guidance/getks',query)
}
//排班列表 按科室
export function getpaibanYs (query) {
  return post(reqURL+'Guidance/getpaiban_ys?'+qs.stringify(query))
}
//号源列表 按医生
export function gethaoyuanYs (query) {
  return post(reqURL+'Guidance/gethaoyuan_ys?'+qs.stringify(query))
}
//挂号记录
export function getguahaolist (query) {
  return post(reqURL+'Guidance/getguahaolist?'+qs.stringify(query))
}
//单个挂号详情
export function getguahaodetail (query) {
  return post(reqURL+'Guidance/getguahaodetail?'+qs.stringify(query))
}
//微信预约挂号
export function yyguahao (birthday,query) {
  return post(reqURL+'Guidance/yyguahao?'+qs.stringify(birthday),query)
}
//获得门诊缴费
export function getmzfeelist (query) {
  return post(reqURL+'Guidance/getmzfeelist?'+qs.stringify(query))
}
// 门诊缴费支付
export function paymzfeelist (query) {
  return post(reqURL+'Guidance/paymzfeelist',query)
}
// 获得住院预交
export function getzyfeelist (query) {
  return post(reqURL+'Guidance/getzyfeelist?'+qs.stringify(query))
}
// 获得我的住院
export function getmyhospital (query) {
  return post(reqURL+'Guidance/getmyhospital?'+qs.stringify(query))
}
// 住院预缴支付
export function payzyfeelist (query) {
  return post(reqURL+'Guidance/payzyfeelist',query)
}
// 每日清单列表
export function getonedayQDfeelist (query) {
  return post(reqURL+'Guidance/getonedayQDfeelist?'+qs.stringify(query))
}
// 住院费用清单列表
export function getzyQDfeelist (query) {
  return post(reqURL+'Guidance/getzyQDfeelist?'+qs.stringify(query))
}
// 报告查询 检验列表
export function getreportjylist (query) {
  return post(reqURL+'Guidance/getreportjylist?'+qs.stringify(query))
}
// 报告查询 检查列表
export function getreportjclist (query) {
  return post(reqURL+'Guidance/getreportjclist?'+qs.stringify(query))
}
// 报告查询 检验列表 详情页
export function getreportjyInfo (query) {
  return post(reqURL+'Guidance/getreportjyInfo?'+qs.stringify(query))
}
// 满意度调查
export function getmanyidulist () {
  return post(reqURL+'Guidance/getmanyidulist')
}
// 缴费记录
export function GetFee (query) {
  return post(reqURL+'Geren/GetFee?'+qs.stringify(query))
}
// 修改就诊卡卡号
export function UpdateHisNo (id,query) {
  return post(reqURL+'HealthCard/UpdateHisNo/'+id + '?'+qs.stringify(query))
}
// 一键授权添加健康卡
export function GetBaseInfo_ByHealthCode (query) {
  return post(reqURL+'HealthCard/GetBaseInfo_ByHealthCode?'+qs.stringify(query))
}
// 微信预约挂号 付款(成功/失败)后调用
export function yyguahao_bypay_after (query) {
  return post(reqURL+'Guidance/yyguahao_bypay_after?'+qs.stringify(query))
}
// 门诊缴费支付 付款(成功/失败)后调用
export function paymzfeelist_bypay_after (query) {
  return post(reqURL+'Guidance/paymzfeelist_bypay_after?'+qs.stringify(query))
}
// 住院预缴支付 付款(成功/失败)后调用
export function payzyfeelist_bypay_after (query) {
  return post(reqURL+'Guidance/payzyfeelist_bypay_after?'+qs.stringify(query))
}
// 解绑电子健康卡
export function DelJiuzhenren (query) {
  return post(reqURL+'Geren/DelJiuzhenren?'+qs.stringify(query))
}
// 微信预约挂号退款
export function yyguahaoTk (query) {
  return post(reqURL+'Guidance/yyguahaoTk?'+qs.stringify(query))
}
// 取消预约
export function cancelYy (query) {
  return post(reqURL+'Guidance/cancelYy?'+qs.stringify(query))
}
// 缴费记录 详情，只看门诊缴费详情
export function GetFeeInfo (query) {
  return post(reqURL+'Geren/GetFeeInfo?'+qs.stringify(query))
}
// 门诊通知
export function GetMznotice () {
  return post(reqURL+'Geren/GetMznotice')
}
// 体检套餐列表
export function getBodyCheckList () {
  return post(reqURL+'Guidance/getBodyCheckList')
}
// 体检套餐付费
export function paybodycheck (query) {
  return post(reqURL+'Guidance/paybodycheck', query)
}
// 体检套餐付费回调
export function paybodycheck_after (query) {
  return post(reqURL+'Guidance/paybodycheck_after?'+ qs.stringify(query))
}
// 问卷列表
export function GetQuestion (query) {
  return post(reqURL+'Geren/GetQuestion?'+ qs.stringify(query))
}
// 提交问卷
export function SaveQuestion (id,query) {
  return post(reqURL+'Geren/SaveQuestion/'+id + '?'+qs.stringify(query))
}
// 新冠肺炎流行病学史问卷
export function Savehiscrownresult (query) {
  return post(reqURL+'Geren/Savehiscrownresult' , query)
}
// 获取病人信息
export function getPatientInfo (query) {
  return post(reqURL+'Geren/getPatientInfo?' + qs.stringify(query))
}
// 获取新冠问卷答案列表
export function gethisCrownresult (query) {
  return post(reqURL+'Geren/GethisCrownresult?' + qs.stringify(query))
}
// 获取新冠问卷答案详情
export function gethisCrownresultDetail (query) {
  return post(reqURL+'Geren/GethisCrownresultDetail?' + qs.stringify(query))
}
// 获取卡包orderid
export function getOrderId (query) {
  return get(reqURL+'HealthCard/GetOrderId?' + qs.stringify(query))
}



// WEBPACK FOOTER //
// ./src/api/index.js